import { render, staticRenderFns } from "./release.vue?vue&type=template&id=ff6551ba&"
import script from "./release.vue?vue&type=script&lang=ts&"
export * from "./release.vue?vue&type=script&lang=ts&"
import style0 from "./release.vue?vue&type=style&index=0&id=ff6551ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports